import { Guid, Id } from "@gemma/typescript-types";

import { Entities } from "@timesheets/webapp-support";
import { IState } from "../../../IState";
import { Store } from "vuex";
import { WireEntities } from "@timesheets/common";

export class Documents implements Entities.Documents.IDocuments {
  private readonly _store: Store<IState>;

  constructor(store: Store<IState>) {
    this._store = store;
  }

  setAllowUploads(allowUploads: boolean, recruitmentAgency: WireEntities.Roles.IRecruitmentAgencyRole | Id<Guid>): void {
    this._store.dispatch("user/documents/setAllowUploads", { allowUploads, recruitmentAgency });
  }
}
